exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".compliance-type-select{padding:0!important}.compliance-type-select .multiselect__single .option__title{line-height:44px}.compliance-type-select .multiselect__caret{line-height:28px}.spacer{margin:0 22px 0 17px}", ""]);

// exports
